import { FC } from 'react';
import styled from './index.module.scss';
import Icon1 from './Icon1';
import Icon2 from './Icon2';
import Icon3 from './Icon3';

interface IProps {
    type?: string;
}

const Additional: FC<IProps> = ({}) => {
    const list = [
        {
            icon: <Icon1 />,
            name: '長期保証',
            desc: '最大5年保証で購入後も安心',
        },
        {
            icon: <Icon2 />,
            name: '送料無料',
            desc: '全商品対象',
        },
        {
            icon: <Icon3 />,
            name: 'エコリサイクルサービス',
            desc: '無料で不要となったポータブル\n電源を回収します',
        },
    ];
    return (
        <div className={styled.Additional}>
            <h6 className="additional_title">
                EcoFlowは便利で信頼できる顧客サービスを提供し、すべてのお客様に
                <br />
                最高のショッピング体験をしていただけるよう努めています
            </h6>
            <div className="text_box">
                {list.map((item) => (
                    <div key={item.name} className="text_item">
                        {item.icon}
                        <div>
                            <p className="item_name">{item.name}</p>
                            <p className="item_desc">{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Additional;
